import { useEffect } from 'react'
import { useThemeStore } from '#src/hooks/useThemeStore.ts'

const DARK_CLASS = 'dark'

const DARK_QUERY = '(prefers-color-scheme: dark)'

// Applies the user's theme choice to Tailwind's `.dark` selector. The theme
// store (`seen-theme`) is the single source of truth — intentionally
// independent of Mantine, which is being removed. Mantine components are not
// driven from here, so they stay light until they are migrated off Mantine.
export function useDarkMode(): void {
  const theme = useThemeStore((s) => s.theme)

  useEffect(() => {
    const root = document.documentElement

    const apply = (): void => {
      const isDark =
        theme === 'dark' ||
        (theme === 'system' && window.matchMedia(DARK_QUERY).matches)
      root.classList.toggle(DARK_CLASS, isDark)
    }

    apply()

    // Only `system` tracks the OS; explicit light/dark needs no listener.
    if (theme !== 'system') {
      return
    }
    const mql = window.matchMedia(DARK_QUERY)
    mql.addEventListener('change', apply)
    return () => mql.removeEventListener('change', apply)
  }, [theme])
}
